module.exports = __webpack_public_path__ + "img/min-players.60a294fa.svg";